<template>
	<div>
		<v-app-bar color="primary" absolute elevate-on-scroll :scroll-target="`#${id}`">
			<v-layout>
				<v-flex>
					<v-toolbar-title class="headline">
						<slot name="header">
							<v-img
								:src="require('../../assets/Moj_Title_Icon.svg')"
								contain
								class="my-2"
								height="80"
							></v-img>
						</slot>
						
					</v-toolbar-title>
				</v-flex>
			</v-layout>
		</v-app-bar>
		<v-sheet :id="id" class="overflow-y-auto" max-height="100vh">
			<v-container class="mt-12">
				<slot name="content"></slot>
			</v-container>
		</v-sheet>
	</div>
</template>

<script>
export default {
	data: () => ({}),
	props: ["id"]
};
</script>

